import { useMemo } from 'react'
import cn from 'classnames'
import { Input, Form, Popover } from 'antd'
import { Props } from './types'
import { Typography, TYPOGRAPHY_WEIGHT } from '../Typography'
import { ReactComponent as InformationIcon } from 'assets/svg/Information.svg'
import './input.default.scss'

export const Default = ({ ...props }: Props): JSX.Element => {
  const helpContent = useMemo(() => {
    const originalHelp = props.propsItem?.help

    if (
      props.warningPopover?.showPopup &&
      !!props.warningPopover?.items?.length
    ) {
      const popoverContent = (
        <div className="column">
          {props.warningPopover?.title && (
            <Typography.Headline6
              className="mb-8"
              weight={TYPOGRAPHY_WEIGHT.BOLD}
            >
              {props.warningPopover?.title}
            </Typography.Headline6>
          )}
          <div className="column">
            {props.warningPopover?.items?.map((name, idx) => (
              <div key={`${name}${idx}`} className="mt-4">
                <Typography.Body2 className="main-dark-color-text">
                  {name}
                </Typography.Body2>
              </div>
            ))}
          </div>
        </div>
      )

      return (
        <div className={cn('row align-center')}>
          <span>{originalHelp}</span>
          <Popover
            content={popoverContent}
            trigger="click"
            placement="top"
            overlayInnerStyle={{
              maxHeight: 500,
              overflow: 'auto'
            }}
          >
            <span className="cursor-pointer">
              <InformationIcon />
            </span>
          </Popover>
        </div>
      )
    }

    return originalHelp
  }, [props.warningPopover, props.propsItem?.help])

  return (
    <Form.Item
      className={cn('custom-input', 'input-default', props.className)}
      {...props.propsItem}
      help={helpContent}
      colon={false}
    >
      <Input {...props.propsInput} />
    </Form.Item>
  )
}
